import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IMainPage, IObjects, IProductAlias, IPrograms, TErrorMainPage } from './types/main-page-interface'

const MainPageState = (state: RootState): IMainPage => state.mainPage


export const Regions = createSelector(
    [MainPageState],
    (state): IObjects[] => state.regions,
)
export const Programs = createSelector(
    [MainPageState],
    (state): IPrograms[] => state.programs,
)
export const SellerID = createSelector(
    [MainPageState],
    (state): string => state.sellerId,
)
export const ProductID = createSelector(
    [MainPageState],
    (state): string => state.productId,
)
export const isLoading = createSelector(
    [MainPageState],
    (state): boolean => state.isLoadingDictionaries,
)
export const doNotShowRegion = createSelector(
    [MainPageState],
    (state): boolean => state.doNotShowRegion,
)
export const Error = createSelector(
    [MainPageState],
    (state): TErrorMainPage => state.errorDictionaries,
)

export const ProductAliasState = createSelector(
    [MainPageState],
    (state): IProductAlias => state.productAlias,
)